import React from 'react';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import authStorage from '../../../storages/mobx/authStorage';
import facebookAuth from '../../providers/facebookAuth';

function FacebookAuthButton() {
  return (
    <button
      className="btn social-btn btn-fb d-inline-block"
      type="button"
      onClick={() => facebookAuth(authStorage.setCredientials, authStorage.processError)}
    >
      <i className="fa fa-facebook" />
    </button>
  );
}

FacebookAuthButton.propTypes = {};

export default FacebookAuthButton;
